const PremiumImpactPageRefData = {
  premiumImpactPaymentAdjustedText: {
    informationText: 'Any changes to your premium will be automatically adjusted in your next payment cycle. Or you can pay the difference now.',
  },
  premiumImpactNoPreviousPremiumText: {
    informationText:
      'We can’t display your previous premium information here. Please check your Certificate of Cover for details which is located within My Documents. You’ll also receive a copy via email or post depending your preferred communication method.',
  },
  premiumImpactPremiumInformationText: {
    informationText: 'Any changes to your premium will be automatically adjusted in your next payment cycle. Or you can pay the difference now',
  },
  noPremiumImpactInformationText: {
    informationText:
      'You can view your premium payment details at any time under your policy holder&rsquo;s profile. Likewise, your claim payment details can be accessed at any time under your member profile. If you&#39;ve recently updated your premium payment details to start on a future date, they may not appear today. Your updated details will be reflected on the day they become effective within the Payment details section.<br />\r\n<br />\r\nYou can also find your payment details in the Certificate of Cover sent to your email and available under My Documents',
  },
  premiumImpactInformationText: {
    informationText: `<p>View your premium payment details in the policy holder’s profile. Claim payment details can be viewed in the member profile. Future dated payment details do not appear until the date they become effective.</p>
    <p>Payment details can also be viewed in your Certificate of Cover (see My Documents)</p>`,
  },
  premiumImpactCalloutText: {
    informationText:
      '<p><strong>How your premium has changed</strong></p>\r\n\r\n<p>Changing your payment frequency and/or payment start date can change how much you have to pay for your next payment and/or ongoing premium payments.​<br />\r\n<br />\r\nAn updated certificate of cover with all the new details will be available under &ldquo;My documents&rdquo; shortly.<br />\r\n<br />\r\nPrevious premium reflects the premium that applied BEFORE any changes were made on the policy today.</p>\r\n',
  },
  relatedPage1: {
    heading: 'Lifetime Health Cover (LHC)',
    description: 'Keep your premiums low by avoiding LHC',
    toUrl: '~/portal/$memberNumber$/Payment-Details',
    imageUrl: '~/getmedia/a5ed6959-586b-448d-9fa6-f7ca81f1d067/world1.jpg?width=1356&height=668&ext=.jpg',
    imageAltText: 'world',
  },
  relatedPage2: {
    heading: 'Private health insurance rebate',
    description: 'Find out how to make health insurance more affordable',
    toUrl: '~/portal/$memberNumber$/my-cover/Change-my-cover',
    imageUrl: '~/getmedia/95d45099-47d5-4b04-b2a6-27fa7fc7bb98/blogimage3.jpg?width=1024&height=682&ext=.jpg',
    imageAltText: 'child',
  },
  relatedPage3: {
    heading: 'Delegation of Authority',
    description: ' Helping you maintain the privacy and security of members on your policy',
    toUrl: '~/portal/Support/Help-HQ',
    imageUrl: '~/getmedia/7e655f95-e5e0-4345-b8d8-4915c65e3482/Kidney-Health.jpg?width=584&height=506&ext=.jpg',
    imageAltText: 'people',
  },
};

const PaymentDetailsPageRefData = {
  paymentDetailsInformationText: {
    informationText:
      '<p><strong>Premium payments</strong><br />\r\nChoose your premium payment method and frequency that suits you. By automating payments from a bank account, you can select a payment date between the 1st and 28th day of the month, the frequency and it&rsquo;s fee-free.<br />\r\n<br />\r\nCredit card direct debits are deducted on the 15th of the month.<br />\r\n<br />\r\n<strong>Claim payments</strong><br />\r\nNominate an account for claims benefits to be paid. Note that policy holders must have an account for claims payments to be paid.</p>',
  },
  premiumPaymentSubheadingText: {
    informationText: '<p>Here’s what we have recorded for your payment details. <br /> <br/ ></p>',
  },
  premiumPaymentEditingSubheadingText: {
    informationText: '<p>Update your payment details by completing the form below. <br /> <br/ ></p>',
  },
  premiumPaymentInvoiceBpayBillerCode: {
    informationText: '5546',
  },
  paymentMethodOptions: [
    {
      display: 'Bank account',
      returnValue: 'B',
    },
    {
      display: 'Credit card',
      returnValue: 'C',
    },
    {
      display: 'Invoice',
      returnValue: 'BILL',
    },
  ],
  paymentFrequencyOptions: [
    {
      display: 'Fortnightly',
      returnValue: 'Fortnightly',
    },
    {
      display: 'Monthly',
      returnValue: 'Monthly',
    },
    {
      display: 'Quarterly',
      returnValue: 'Quarterly',
    },
    {
      display: 'Semi-annual',
      returnValue: 'Semi-annual',
    },
    {
      display: 'Annual',
      returnValue: 'Annual',
    },
  ],
  premiumPaymentCalloutText: {
    informationText:
      'If you&rsquo;ve recently updated your premium payment details to start on a future date, they will not appear today. Your new details will appear on the specified future date.',
  },
  premiumPaymentCreditCardCalloutText: {
    informationText: 'Credit card payments are made on the 15th of each month, quarter, half year or year​.',
  },
  claimsAccountNotPolicyHolderCalloutText: {
    informationText: 'Please note if the policy holder changes their details, you will also need to update your account details.&nbsp;',
  },
  premiumPaymentBankAccountCalloutText: {
    informationText: 'Your policy is currently paid up to #{dpt}. Please select a start date between the 1st and 28th day of the month and after your date paid to.',
  },
  premiumPaymentInvoiceCalloutText: {
    informationText: 'Your policy is currently paid up to #{dpt}. Invoices are sent 28 days in advance of the payment date.',
  },
  claimsAccountInformationText: {
    informationText: '<p>When you next submit a claim with us, we will deposit any benefits into your bank account below.</p>',
  },
  premiumPaymentCreditCardPaymentFeeText: {
    informationText: '',
  },
  reviewAndSubmitDirectDebitAcknowledgementText: {
    informationText:
      '<p>I have read and understood the <a href="https://www.defencehealth.com.au/getmedia/fa92e476-6635-4e16-86f7-3aaee8f9d40d/direct-debit-service-agreement.pdf" target="_blank">Direct Debit service agreement</a>. I understand that the first deduction after the enrolment or change date may include the payment frequency nominated plus an adjustment amount. I also understand that if any deduction falls on a non-business day, it will be debited from my account on the next business day following the scheduled date. I authorise Defence Health to alter the amount of the deduction, should the rate for any product to which I contribute be changed. I understand that it is a condition of my Defence Health cover that premiums are to be paid in advance at all times. Any changes to contribution amount or frequency must be requested at least 2 days prior to the next deduction.</p>',
  },
  reviewAndSubmitPrivacyInformationText: {
    informationText:
      '<p><b>Privacy</b></br>We have collected your payment details in order that you may pay your premiums by direct debit.  Your information will be given to our service provider which arrange these payments. More information about how Defence Health manages your personal information is available in our <a href="https://www.defencehealth.com.au/getmedia/cc77f950-11e8-4db3-b2ab-926bec15f027/4-4b-privacy-policy.pdf" target="_blank">Privacy Policy</a>.  The Privacy Policy includes information about how you may access and correct your personal information and make a complaint.</p>',
  },
  reviewAndSubmitReviewInformationText: {
    informationText: '<p>Please review your updates before submitting the changes.</p><p>If something doesn’t look right, please go back and edit your details.</p>',
  },
  claimsAccountCalloutText: {
    informationText: '<p>If you update your claims account, any claims submitted prior to today will be paid into your previously stored bank account.</p>\r\n',
  },
  claimsAccountPrivacyInformationText: {
    informationText: `<p><strong>Privacy and your personal information</strong></p>
    <p>
      The privacy and security of your personal information is important to us, and is protected by law. We need to collect this information so we can process and manage your
      applications and payments, and provide services to you. We only share your information with other parties where you have agreed, or where law allows or requires it.
    </p>
    <p>
      For more information, go to
      <a href="https://servicesaustralia.gov.au/privacy" target="_blank">servicesaustralia.gov.au/privacy</a>
    </p>`,
  },
  claimsAccountAuthorisationText: {
    informationText:
      '<p>I authorise Defence Health to pay this membership’s claims benefits directly into my nominated account. I acknowledge that the claims payments for this membership will continue to be paid to my nominated account until I register a new account.</p>',
  },
  claimsAccountLimitedAccessMemberCalloutText: {
    informationText:
      'A claims account is optional for members with limited access. If a claims account is not provided you can still claim and select the policy holder&rsquo;s account to receive the benefits.',
  },
  claimsAccountDuplicateDetailsText: {
    informationText: 'The details you have entered match the details you have nominated for premium payments. Your response has been updated.',
  },
};

const PaymentSelectionRefData = {
  paymentSelectionInformationText: {
    informationText: `<p>Policy holders and full access members can update the policy payment method and or frequency. Select the policy holder’s profile to update payment details.</p>\n
    <p>If the policy holder has enabled their privacy, only they can view and edit the payment method.</p>\n
    <p>If you need to make an immediate payment,&nbsp;<a href="/$memberNumber$/Support/Contact-Us" target="_blank">drop us a line</a>, or chat with us and we'll be happy to help. Soon you’ll be able to make immediate payments, adjust your rebate and excess.</p>`,
  },
  paymentSelectionCalloutText: {
    informationText:
      '<h2><strong>Keep your payment details up to date</strong></h2>\r\n\r\n<ul><li>Take a few moments to make sure your details are correct.</li><li>Soon each member on the policy will be able to nominate a separate account to receive their claim benefit payments</li>',
  },
  paymentSelectionSubheadingText: {
    informationText: `<p>Select the policy holder’s profile to update premium payment details.</p>
    <p>Soon each member on the policy will be able to nominate a separate account to receive their claim benefit payments.</p>
    <p>If you can’t access the policy holder’s profile you have insufficient access and the policy holder will need to make the required updates.</p>`,
  },
  relatedPage1: {
    heading: 'Lifetime Health Cover (LHC)',
    description: 'Keep your premiums low by avoiding LHC',
    toUrl: '~/portal/$memberNumber$/Payment-Details',
    imageUrl: '~/getmedia/06ccfb89-2fbf-45df-b220-ead225c4fbd0/large.jpg?width=2400&height=854&ext=.jpg',
    imageAltText: 'bridge',
  },
  relatedPage2: {
    heading: 'Private health insurance rebate',
    description: 'Find out how to make health insurance more affordable',
    toUrl: '~/portal/$memberNumber$/my-cover/Change-my-cover',
    imageUrl: '~/getmedia/4a1f9458-497e-4452-9922-f9bd54c93366/dog.jpg?width=719&height=730&ext=.jpg',
    imageAltText: 'dog',
  },
  relatedPage3: {
    heading: 'Delegation of Authority',
    description: ' Helping you maintain the privacy and security of members on your policy',
    toUrl: '~/portal/Support/Help-HQ',
    imageUrl: '~/getmedia/4d7de997-b135-4677-95ce-764a195585ae/image100.jpg?width=275&height=183&ext=.jpg',
    imageAltText: 'red',
  },
};

export { PremiumImpactPageRefData, PaymentDetailsPageRefData, PaymentSelectionRefData };
